// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"a1d7b105","212":"7e3641ec","281":"70b03d14","291":"5de34256","533":"113923fd","623":"5af61bc2","725":"cf6117cc","838":"acf79507","891":"6cbc0bbd"}[chunkId] + ".chunk.js";
};